import { DataTypeProvider } from '@devexpress/dx-react-grid';
import Box from '@mui/system/Box';
import Typography from '@mui/material/Typography';

import NRTag from '../../../components/NRTag/NRTag';
import { CONSTANTS } from '../../../constants/constants';

const { BADGES } = CONSTANTS.TABLE.SBOM_TABLE.SBOM_DETAIL_DRAWER;

const OnDiskFormatter = ({ value }) => {
  if (!value) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center">
        <Typography variant="body2" color="text.secondary">
          -
        </Typography>
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <NRTag text={BADGES.FOUNDONDISK.LABEL} tooltipContent={<span style={{ whiteSpace: 'pre-line' }}>{BADGES.FOUNDONDISK.TOOLTIP}</span>} />
    </Box>
  );
};
export const NROnDiskProvider = props => <DataTypeProvider formatterComponent={OnDiskFormatter} {...props} />;
